import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetDoctorDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Doctor/GetDetail?` + params, null);

export const GetDoctorList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Doctor/GetList?` + params, null);

export const CreateDoctor = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Doctor/Create`, data, true);

export const UpdateDoctor = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Doctor/Update`, data, true);

export const DeleteDoctor = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Doctor/Delete`, data);

export const GetDoctorListForSelect = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Doctor/GetListForSelect?` + params, null);

export const ImportDoctorFromExcel = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Doctor/ImportFromExcel`, data);